import React, { Suspense, useEffect } from 'react';

import Header from 'components/Header/Header';
import MenuDrawer from 'components/MenuDrawer/MenuDrawer';
import NotificationsDrawer from 'components/NotificationsDrawer/NotificationsDrawer';
import PageLoader from 'components/PageLoader/PageLoader';
import ErrorBoundary from 'containers/ErrorBoundary/ErrorBoundary';
import useLayoutStore from 'storages/layout';

type Props = {
  children: React.ReactNode;
};

const LayoutAuthorized: React.FC<Props> = ({ children }) => {
  const { isMenuVisible, isNotificationsVisible, toggleIsMenuVisible, toggleIsNotificationsVisible, setIsReportProblemMenuAvailable } =
    useLayoutStore();

  useEffect(() => {
    setIsReportProblemMenuAvailable(true);

    return () => {
      setIsReportProblemMenuAvailable(false);
    };
  }, [setIsReportProblemMenuAvailable]);

  return (
    <ErrorBoundary name='layout-authorized'>
      <div>
        <Header />
        {/* Keep shell (header + drawers) outside route Suspense so the menu can close on click
            while the next lazy page is still loading. */}
        <Suspense fallback={<PageLoader />}>{children}</Suspense>
        <NotificationsDrawer isOpen={isNotificationsVisible} onClose={toggleIsNotificationsVisible} />
        <MenuDrawer isOpen={isMenuVisible} onClose={toggleIsMenuVisible} />
      </div>
    </ErrorBoundary>
  );
};

export default LayoutAuthorized;
